import type { ILocalizedText } from '@platform/core/types';
import type { IModuleTypesText } from './IModuleTypesText';
import type { ITypeRow } from './ITypeRow';

/**
 * Типи запису рядка (прототип v4 modParts: «Case · +6 designed», «Case form · +6 designed»): однина типу (для колонки «Форми» — «Форма «…»»)
 * і «+N спроєктовано» — сутності MOD_ENTITIES типу (`designEntities` без `extra`; старіше визначення без них — спроєктовані таблиці типу);
 * підказка — повний перелік. Чиста функція.
 */
export function typeRowText(row: ITypeRow, name: (text: ILocalizedText | null | undefined) => string,
  t: (key: string, vars?: Record<string, unknown>) => string, form = false): IModuleTypesText {
  const wrap = (s: string) => (form ? t('sysCust.formOf', { name: s }) : s);
  const head = wrap(name(row.rt.singular ?? row.rt.name));
  const entities = (row.rt.designEntities ?? []).filter((e) => !e.extra);
  const parts = row.rt.designEntities ? entities.map((e) => name(e.name)) : row.designed.map((r) => name(r.singular ?? r.name));
  return {
    text: parts.length ? `${head} · ${t('sysCust.designed', { count: parts.length })}` : head,
    tip: [head, ...parts.map(wrap)].join(', '),
  };
}
